"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  return obj && obj.__isYupSchema__;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/isSchema.js
// module id = 74
// module chunks = 0